// extracted by mini-css-extract-plugin
module.exports = {"customScrollbar":"tableOfContent_customScrollbar__OUjIz"};